import { graphql } from "@/graphql/generated/gql";

export const entityPermissionListForEntityQueryDocument = graphql(/* GraphQL */ `
  query entityPermissionListForEntity($input: GetEntityPermissionListInput!) {
    entityPermissionListForEntity(input: $input) {
      id
      entityId
      entityType
      userId
      teamId
      right
      sourceTeamId
      createdAt
      updatedAt
      user {
        id
        email
        username
        fullname
        profilePicture
      }
      team {
        id
        name
        logo
        logoType
        color
      }
    }
  }
`);

export const effectiveEntityRightQueryDocument = graphql(/* GraphQL */ `
  query effectiveEntityRight($input: GetEffectiveEntityRightInput!) {
    effectiveEntityRight(input: $input)
  }
`);

export const setEntityPermissionMutationDocument = graphql(/* GraphQL */ `
  mutation setEntityPermission($input: SetEntityPermissionInput!) {
    setEntityPermission(input: $input) {
      id
      entityId
      entityType
      userId
      teamId
      right
      sourceTeamId
    }
  }
`);

export const hiddenEntityCountQueryDocument = graphql(/* GraphQL */ `
  query hiddenEntityCount($input: GetHiddenEntityCountInput!) {
    hiddenEntityCount(input: $input)
  }
`);

export const removeEntityPermissionMutationDocument = graphql(/* GraphQL */ `
  mutation removeEntityPermission($input: RemoveEntityPermissionInput!) {
    removeEntityPermission(input: $input)
  }
`);

export const shareEntityWithWorkspaceMutationDocument = graphql(/* GraphQL */ `
  mutation shareEntityWithWorkspace($input: ShareEntityWithWorkspaceInput!) {
    shareEntityWithWorkspace(input: $input)
  }
`);

export const bulkSetEntityPermissionMutationDocument = graphql(/* GraphQL */ `
  mutation bulkSetEntityPermission($input: BulkSetEntityPermissionInput!) {
    bulkSetEntityPermission(input: $input) {
      successCount
      errorCount
    }
  }
`);
